<template>
    <b-dropdown
        v-if="items.length > 0"
        :text="title"
        variant="link"
        toggle-class="dashboard-title"
    >
        <b-dropdown-item
            v-for="(item, index) in items"
            :key="index"
            :to="item.to"
            >{{ item.text }}
        </b-dropdown-item>
    </b-dropdown>
    <b-button
        v-else
        variant="link"
        class="dashboard-title text-decoration-none"
    >
        {{ title }}
    </b-button>
</template>

<script>
import { hasAccess as hasFozChapecoAccess } from "@/modules/foz_chapeco/services";
import {
    HOME_ROUTE_NAME as fozChapecoHome,
    TITLE as fozChapecoTitle
} from "@/modules/foz_chapeco/settings";
import { hasAccess as hasCamposNovosAccess } from "@/modules/campos_novos/services";
import {
    HOME_ROUTE_NAME as camposNovosHome,
    TITLE as camposNovosTitle
} from "@/modules/campos_novos/settings";
import { hasAccess as hasJulho14Access } from "@/modules/julho_14/services";
import {
    HOME_ROUTE_NAME as julho14Home,
    TITLE as julho14Title
} from "@/modules/julho_14/settings";

const RouteNameToPermMap = {
    [fozChapecoHome]: {
        hasPermission: hasFozChapecoAccess,
        title: fozChapecoTitle
    },
    [camposNovosHome]: {
        hasPermission: hasCamposNovosAccess,
        title: camposNovosTitle
    },
    [julho14Home]: {
        hasPermission: hasJulho14Access,
        title: julho14Title
    }
};

export default {
    name: "PageTitleSelector",
    data() {
        return {
            items: []
        };
    },
    computed: {
        title() {
            if (this.$route.matched.length > 0) {
                return this.$route.matched[0].meta.title;
            }
            return "";
        }
    },
    async mounted() {
        if (this.$route.matched.length > 0) {
            const route = this.$route.matched[0];
            const items = [];

            switch (route.name) {
                case fozChapecoHome:
                    await this.addItem(camposNovosHome, items);
                    await this.addItem(julho14Home, items);
                    break;
                case "campos_novos":
                    await this.addItem(fozChapecoHome, items);
                    await this.addItem(julho14Home, items);
                    break;
                default:
                    await this.addItem(fozChapecoHome, items);
                    await this.addItem(camposNovosHome, items);
                    break;
            }

            this.items = items;
        }
    },
    methods: {
        async addItem(routeName, items) {
            if (await RouteNameToPermMap[routeName].hasPermission()) {
                items.push({
                    text: RouteNameToPermMap[routeName].title,
                    to: {
                        name: routeName
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ .dashboard-title {
    text-decoration: none;
    color: #333333;
    font-size: 1.125rem;
    transition: opacity ease-in-out 0.15s;

    &:focus {
        box-shadow: none;
    }

    &:hover {
        opacity: 0.75;
    }
}
</style>
